import { z } from "zod";
export const UserTrackingSubmitArgs = z.object({
    action: z.string(),
});
export const UserTrackingGetUsersResponse = z.object({
    users: z.array(z.object({
        id: z.number(),
        email: z.string(),
        name: z.string(),
        isAuthenticated: z.boolean(),
        profilePicture: z.string().optional(),
        actions: z
            .array(z.object({
            action: z.string(),
            count: z.number(),
            timestamp: z.string(),
        }))
            .optional(),
    })),
});
export const UserActionSubmitArgs = z.object({
    userId: z.number(),
    action: z.string(),
    component: z.string().optional(),
    socketId: z.string(),
});
export const UserActionSubmitResponse = z.object({
    userId: z.number(),
    actionCounts: z.record(z.object({
        count: z.number(),
        lastTimestamp: z.string(),
        totalTimeSpent: z.number().optional(),
    })),
});
export const UserTrackingGetUserActionCountsArgs = z.object({
    userId: z.number(),
});
export const GetUserActivityMetricsArgs = z.object({
    date: z.string().optional(),
    timeRange: z
        .object({
        from: z.string(),
        to: z.string(),
    })
        .optional(),
});
export const UserActivityMetricsResponse = z.object({
    dau: z.number(),
    mau: z.number(),
    ratio: z.number(),
    timestamp: z.string(),
});
//# sourceMappingURL=usertracking.js.map